import { del, get, post, put } from '../utility/http';
import { ICertificate } from '../model/profileInterface';

export async function fetchProfiles() {
  try {
    const response = await get('/users/profiles', true);
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchProfile() {
  try {
    const response = await get('/users/profile', true);
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchProfileByUsername(username: string) {
  try {
    const response = await get(`/users/profile/${username}`, true);
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function addPicProfile(body: any) {
  try {
    const response = await post(
      '/users/profile/profile-pic',
      true,
      {},
      body,
      false,
      true,
      'multipart/form-data'
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function addProfile(body: any) {
  try {
    const response = await post('/users/profile', true, {}, body);
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function editDetailsProfile(body: any) {
  try {
    const userRole = localStorage.getItem('userRole') ?? null;
    const isAdmin = userRole && userRole === 'ADMIN' ? true : false;
    const response = await put('/users/profile', true, { isAdmin }, body);
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function editProfileByUsername(body: any) {
  try {
    const isAdmin = body?.userDto?.roles.includes('ADMIN') ? true : false;
    const response = await put(
      `/users/profile/${body?.userDto?.keycloakUser?.username}`,
      true,
      { isAdmin },
      body
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function deleteProfile(username: string) {
  try {
    const response = await del(`/users/profile/${username}`, true);
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function changeProfilePassword(
  username: string,
  oldPassword: string,
  newPassword: string,
  temporary: boolean
) {
  try {
    const response = await post(
      '/users/reset-password',
      false,
      {},
      {
        username,
        oldPassword,
        newPassword,
        temporary
      }
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function resetProfilePassword(username: string, password: string,
  oldPassword = 'old' 
) {
  try {
    const response = await post(
      '/users/reset-password',
      true,
      {},
      {
        username,
        oldPassword: oldPassword,
        newPassword: password,
        temporary: true
      }
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function getLicenseTypes() {
  try {
    const response = await get(
      '/certificates',
      true,
      {}
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function pilotIsAllowed(pilot: string, sailLevel: string) {
  try {
    const response = await get(
      `/certificates/${pilot}/isAllowed/${sailLevel}`,
      true,
      {}
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function createPilotCertificate(label: string, description: string) {
  try {
    const response = await post(
      '/certificates/certificate',
      true,
      {},
      {
        label: label,
        description: description
      }
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function updatePilotCertificate(id: number, label: string, description: string) {
  try {
    const response = await put(
      `/certificates/certificate/${id}`,
      true,
      {},
      {
        label: label,
        description: description
      }
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function deletePilotCertificate(id: number) {
  try {
    const response = await del(
      `/certificates/certificate/${id}`,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function addRequestedCertificates(sailLevel: string, certificates: ICertificate[]) {
  try {
    const response = await put(
      `/certificates/saillevel/${sailLevel}`,
      true,
      {},
      certificates
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function deleteRequestedCertificate(sailLevel: string, certificates: ICertificate[]) {
  try {
    const response = await del(
      `/certificates/saillevel/${sailLevel}`,
      true,
      {},
      certificates
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

